import {useState, useCallback} from 'react';

export const useAccordion = (defaultState = {}) => {
	const [accordions, setAccordions] = useState(defaultState);

	const toggle = useCallback((key) => {
		setAccordions(prev => ({...prev, [key]: !prev[key]}));
	}, []);

	const setAccordion = useCallback((key, value) => {
		setAccordions(prev => ({...prev, [key]: value}));
	}, []);

	const isOpen = useCallback((key) => {
		return accordions[key] || false;
	}, [accordions]);

	return {accordions, toggle, setAccordion, isOpen};
};